import type { ListOverrides } from 'baseui/list';
import type { TagOverrides } from 'baseui/tag';
export const getTagOverrides = (isSelected: boolean): TagOverrides => {
  return {
    Root: {
      style: ({
        $theme
      }) => ({
        margin: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        padding: `${$theme.sizing.scale0} ${$theme.sizing.scale100}`,
        height: $theme.sizing.scale700,
        backgroundColor: isSelected ? $theme.colors.blue100Dark : $theme.colors.blue100,
        color: isSelected ? $theme.colors.blue700Dark : $theme.colors.blue700
      })
    },
    Text: {
      style: ({
        $theme
      }) => ({
        ...$theme.typography.LabelXSmall
      })
    }
  };
};
export const getLabelListItemOverrides = (isSelected: boolean, isLast?: boolean): ListOverrides => ({
  Root: {
    style: ({
      $theme
    }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: isSelected || isLast ? '1px solid transparent' : `1px solid ${$theme.colors.borderOpaque}`,
      padding: `${$theme.sizing.scale100} ${$theme.sizing.scale300}`,
      width: '100%',
      backgroundColor: isSelected ? $theme.colors.backgroundTertiary : 'transparent',
      borderRadius: isSelected ? $theme.borders.radius300 : 'none',
      transitionProperty: 'background-color, border',
      transitionDuration: '0.2s',
      transitionTimingFunction: 'ease-in',
      ':active': {
        backgroundColor: $theme.colors.backgroundSecondary,
        borderRadius: $theme.borders.radius300
      }
    })
  },
  ArtworkContainer: {
    style: ({
      $theme
    }) => ({
      minHeight: 0,
      width: 'auto',
      paddingRight: $theme.sizing.scale500
    })
  },
  Content: {
    style: ({
      $theme
    }) => ({
      minHeight: 0,
      padding: 0,
      gap: $theme.sizing.scale200
    })
  },
  EndEnhancerContainer: {
    style: {
      padding: 0
    }
  }
});